export default __webpack_public_path__ + "static/media/gallery_25.d8b5bec9.jpg";